import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideTranslateService } from '@ngx-translate/core';
import { translateHttpLoaderProvider } from './shared/HttpLoaderFactory';
import { MarkdownModule } from 'ngx-markdown';
import { authInterceptor } from './guards/auth.interceptor';
import { LanguageService } from './services/language.service';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './guards/msal-config';
import { APP_BASE_HREF } from '@angular/common';


export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    provideClientHydration(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions({
        onViewTransitionCreated: ({ transition }) => {
          transition.finished.catch(() => {});
        }
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor])
    ),
    provideAnimations(),
    provideTranslateService({
      fallbackLang: 'en',
      lang: 'en'
    }),
    ...translateHttpLoaderProvider,
    provideAppInitializer(() => inject(LanguageService).initialize()),
    importProvidersFrom([
      MarkdownModule.forRoot(),
      MsalModule.forRoot(
        new PublicClientApplication(msalConfig),
        {
          interactionType: InteractionType.Popup,
          authRequest: {
            scopes: ['user.read']
          }
        },
        {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', ['user.read']],
            ['https://your-backend-api.com/api', ['api://your-backend-api/.default']]
          ])
        }
      ),
    ]),
    // MSAL Providers
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
};
